import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Skeleton } from "antd";
import {
  LogoutIcon
} from "../../assets/index";
import {
  SideBarStyle,
  SideBarTabStyle,
} from "../../components/SideBar/SideBar.style";
import {
  SPOTIFY_CODE,
  SPOTIFY_TOKEN,
  SPOTIFY_USER_INFO
} from "../../constants/storage";
import { useLoginContext } from "../../context";
import { usePlaylistContext } from "../../context/PlaylistContext";
import { usePackageContext } from "../../context/PackageContext";
import { Auth0Logout, deleteItemFromStorage, isEmptyOrNil } from "../../utils";

interface SideBarProps {}

type SideBarTabProps = {
  title: string;
  icon?: React.ReactNode;
  className?: string;
  url?: string;
  onClick?: () => void;
  isActive?: boolean;
};

const SideBarTab = (props: SideBarTabProps) => {
  const { title, icon, className, url, onClick, isActive } = props;

  const navigate = useNavigate();

  const handleTabClick = () => {
    if (!isEmptyOrNil(onClick)) {
      onClick();
      return;
    }

    if (!url) return;

    navigate(url);
  };

  return (
    <SideBarTabStyle
      className={`${className} ${isActive ? "active" : ""}`}
      onClick={handleTabClick}
    >
      {icon}
      <p className="title" title={title}>
        {title}
      </p>
    </SideBarTabStyle>
  );
};

const SideBar: React.FC<SideBarProps> = () => {
  const { state } = usePlaylistContext();
  const { dispatch } = useLoginContext();
  const { clearCache } = usePackageContext();

  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    setTheme(state?.isWholeTheme === false ? "dark" : "light");
  }, [state]);


  const handleLogout = () => {
    deleteItemFromStorage(SPOTIFY_TOKEN);
    deleteItemFromStorage(SPOTIFY_CODE);
    deleteItemFromStorage(SPOTIFY_USER_INFO);
    localStorage.removeItem("userInfo");
    localStorage.removeItem("spotifyUser");

    // Clear package cache
    clearCache();

    Auth0Logout();
      
      dispatch({
      type: "SET_LOGIN",
      payload: false,
    });
  };
  const array = [1, 2, 3, 4, 5, 6];
  return (
    <SideBarStyle>
      <div>
        {theme === "dark" ? (
          <img
            className="logo-image"
            src="./static/songplace.png"
            alt="songplace-logo"
           
          />
        ) : (
          <img
            className="logo-image"
            id="logo-image1"
            src="./static/logo.png"
            alt="songplace-logo"
         
          />
        )}
        {/* <Switch  onChange={ThemeToggler} /> */}
        <div className="tab-wrapper">
          <div className="divs">
            <Skeleton.Button active className="skeleton-button1" />
            <br />
            <Skeleton.Button active className="skeleton-button1" />
          </div>
          {/* <SideBarTab icon={<SearchIcon />} title="Search" url="/search" /> */}
        </div>
        <div className="tab-wrapper">
         
          <div className="divs" style={{}}>
            <Skeleton.Button active className="skeleton-button1" style={{}} />
          </div>
        </div>
      </div>

      <div className="playlist-wrapper">
        <div>{/* <CreatePlayList /> */}</div>
        <div className="playlist-items">
          <div className="playlist-items1">
            <div className="divs">
              {array &&
                array.length > 0 &&
                array.map((c, index) => {
                  return (
                    <Skeleton.Button active className="skeleton-button2" />
                  );
                })}
            </div>

          </div>
        </div>
      </div>
      <div className="tab-wrapper">

        <div className="divs">
          <Skeleton.Button active className="skeleton-button" style={{}} />
        </div>
        <SideBarTab
          className="logout-button"
          icon={
            theme === "dark" ? (
              <LogoutIcon color={"white"} />
            ) : (
              <LogoutIcon color={"#1D1D1D"} />
            )
          }
          title="Logout"
          onClick={() => handleLogout()}
        />
      </div>
    </SideBarStyle>
  );
};

export default SideBar;
